import { Injectable } from "@angular/core";
import {HttpBackend, HttpClient} from "@angular/common/http";

/**
 * This is a second httpClient used for the public Routes. it is working like the normal httpClient from Angulars
 * dependency injection System, except that it is not using the http interceptors.
 */
@Injectable({
	providedIn: 'root'
})
export class PublicHttpService {
	private readonly _publicHttpClient: HttpClient;

	constructor(
		private httpBackend: HttpBackend
	) {
		this._publicHttpClient = new HttpClient(this.httpBackend);
	}

	get publicHttpClient() {
		return this._publicHttpClient;
	}
}
